var rhinestonesId = 28858733825;
  
Shopify.getCart(function(cart) {
    var inCart = false;
    $.each(cart.items, function(index, item) {
      if (item.variant_id == rhinestonesId) {
        inCart = true;
        return false;
      }
    }); 
  
  if (inCart) { removeRhinestones(); } 
  
});


function removeRhinestones() {     
      	Shopify.changeItem(rhinestonesId, 0, function(cart) {
        location.reload();
      });
} 
  
  
function removeRhinestones1() {     
      	Shopify.changeItem(rhinestonesId, 0, function(cart) {
        return true;
      });
}   
  
function addRhinestones1() { 
      	Shopify.addItem(rhinestonesId, rsfinalcount, function(item) {
	  	  return true;        
      	});
}   
  
function addRhinestones() {  
  if (rsfinalcount > 0) { addRhinestones1(); }
}   
